import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Inspection, InspectionOrderField } from '../../shared/models/index';
import { ConnectionCheck } from '../../utils/connection-check';

@Component({
    selector: 'inspection-list-table',
    templateUrl: './list.component.html',
    standalone: false
})
export class InspectionListComponent {
  @Input() public inspections: Inspection[];
  @Output() public toggleSelectInspection: EventEmitter<any> = new EventEmitter();
  @Output() public toggleSort: EventEmitter<InspectionOrderField> = new EventEmitter();
  @Output() public toggleScroll: EventEmitter<InspectionOrderField> = new EventEmitter();
  @Output() public toggleReport: EventEmitter<Inspection> = new EventEmitter();
  @Input() orderBy: InspectionOrderField;
  inspectionOrderField = InspectionOrderField;
  extendedColumn = InspectionOrderField.ByEquipmentType;

  public selectInspection(inspection: Inspection) {
    if (inspection.lastSyncDate || this.isConnection) {
      this.toggleSelectInspection.emit(inspection);
    }
  }

  public setOrderBy(newOrderBy: InspectionOrderField) {
    if (!this.isConnection) return;
    this.orderBy = Math.abs(this.orderBy) === newOrderBy ? -this.orderBy : newOrderBy;
    this.toggleSort.emit(this.orderBy);
  }

  extend(event: Event, column) {
    event.stopPropagation();
    this.extendedColumn = column;
  }

  public get isConnection() {
    return ConnectionCheck.isConnection;
  }

  scroll(event: Event) {
    if (!this.isConnection) return;

    const target = event.target as HTMLDivElement;
    if (target.scrollHeight - target.clientHeight - target.scrollTop < 600) {
      this.toggleScroll.emit();
    }
  }

  openReport(inspection: Inspection, event: Event) {
    event.stopPropagation();
    this.toggleReport.emit(inspection);
  }
}
